import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

interface TicketFormButtonsProps {
  isPending: boolean;
  onCancel?: () => void;
}

export function TicketFormButtons({ isPending, onCancel }: TicketFormButtonsProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleCancel = onCancel ?? (() => navigate('/tickets/select'));

  return (
    <div className="flex gap-4">
      <Button type="submit" disabled={isPending} className="w-full md:w-auto">
        {isPending ? t('forms.submitting') : t('forms.submit')}
      </Button>
      <Button type="button" variant="outline" onClick={handleCancel} disabled={isPending}>
        {t('forms.cancel')}
      </Button>
    </div>
  );
}
